import {
  ArrowLeftRight,
  Backpack,
  Boxes,
  Briefcase,
  Building2,
  CalendarDays,
  Building,
  ClipboardCheck,
  ClipboardList,
  FileCheck2,
  FileSignature,
  FileText,
  GraduationCap,
  HandCoins,
  Headset,
  House,
  Landmark,
  ChartNoAxesCombined,
  type LucideIcon,
  ListChecks,
  MapPinCheck,
  Megaphone,
  Package,
  Palmtree,
  Receipt,
  ReceiptText,
  Users,
  UserRound,
  Settings,
  Stethoscope,
  Tags,
  Truck,
  UsersRound,
  Wallet,
} from 'lucide-react'

import {
  FINANCEIRO_CONSULTA,
  INVENTARIO_CONSULTA,
  INVENTARIO_GESTAO,
  INVENTARIO_MINHA_EQUIPE,
  OPERACIONAL_CALENDARIO,
  OPERACIONAL_PAINEL,
  OPERACIONAL_PLANEJAMENTO,
  OPERACIONAL_RELATORIOS,
  OPERACIONAL_REVISAO,
  ROLES,
} from '@/lib/auth/roles'

export interface NavItem {
  to: string
  label: string
  icon: LucideIcon
  /** Se ausente, visível a qualquer usuário autenticado. */
  roles?: readonly string[]
  /** Marca correspondência exata (para não acender "/" em toda rota). */
  end?: boolean
}

export interface NavSection {
  id: string
  /** Sem título: itens soltos, sempre visíveis (não viram acordeão). */
  title?: string
  /** Ícone da seção — é o que aparece na sidebar minimizada. */
  icon?: LucideIcon
  items: NavItem[]
}

export const NAV_SECTIONS: NavSection[] = [
  {
    id: 'inicio',
    items: [{ to: '/', label: 'Início', icon: House, end: true }],
  },
  {
    id: 'meu-espaco',
    title: 'Meu espaço',
    icon: UserRound,
    items: [
      { to: '/meu-perfil', label: 'Meu perfil', icon: UserRound },
      { to: '/contracheque', label: 'Contracheque', icon: FileText },
      { to: '/meus-atestados', label: 'Atestados', icon: Stethoscope },
      { to: '/meus-avisos-ferias', label: 'Férias', icon: Palmtree },
      { to: '/meus-treinamentos', label: 'Treinamentos', icon: GraduationCap },
      { to: '/meus-comunicados', label: 'Comunicados', icon: Megaphone },
      { to: '/meus-eventos', label: 'Eventos', icon: CalendarDays },
      { to: '/meus-itens', label: 'Meus itens', icon: Backpack },
      { to: '/minhas-visitas', label: 'Visitas', icon: MapPinCheck },
      { to: '/atendimento', label: 'Atendimento', icon: Headset },
    ],
  },
  {
    id: 'rh',
    title: 'Recursos Humanos',
    icon: Briefcase,
    items: [
      {
        to: '/rh',
        label: 'Visão Geral RH',
        icon: ChartNoAxesCombined,
        // O supervisor geral só vê o bloco de atestados (ver RhDashboardPage).
        roles: [ROLES.RH, ROLES.SUPERVISOR_GERAL],
        end: true,
      },
      { to: '/rh/colaboradores', label: 'Colaboradores', icon: Users, roles: [ROLES.RH] },
      { to: '/rh/comunicados', label: 'Comunicados', icon: Megaphone, roles: [ROLES.RH] },
      { to: '/rh/eventos', label: 'Eventos', icon: CalendarDays, roles: [ROLES.RH] },
      { to: '/rh/ferias', label: 'Férias', icon: Palmtree, roles: [ROLES.RH] },
      { to: '/rh/treinamentos', label: 'Treinamentos', icon: GraduationCap, roles: [ROLES.RH] },
      { to: '/rh/configuracoes', label: 'Configurações', icon: Settings, roles: [ROLES.RH] },
    ],
  },
  {
    id: 'diretoria',
    title: 'Diretoria',
    icon: Landmark,
    items: [
      {
        to: '/rh',
        label: 'Visão Geral RH',
        icon: ChartNoAxesCombined,
        roles: [ROLES.DIRETORIA],
        end: true,
      },
      {
        to: '/financeiro',
        label: 'Visão Geral Financeiro',
        icon: Wallet,
        roles: [ROLES.DIRETORIA],
        end: true,
      },
      {
        to: '/operacional',
        label: 'Visão Geral Operacional',
        icon: MapPinCheck,
        roles: [ROLES.DIRETORIA],
        end: true,
      },
      { to: '/rh/colaboradores', label: 'Colaboradores', icon: Users, roles: [ROLES.DIRETORIA] },
      { to: '/rh/comunicados', label: 'Comunicados', icon: Megaphone, roles: [ROLES.DIRETORIA] },
      { to: '/rh/eventos', label: 'Eventos', icon: CalendarDays, roles: [ROLES.DIRETORIA] },
      { to: '/rh/ferias', label: 'Férias', icon: Palmtree, roles: [ROLES.DIRETORIA] },
      {
        to: '/rh/treinamentos',
        label: 'Treinamentos',
        icon: GraduationCap,
        roles: [ROLES.DIRETORIA],
      },
    ],
  },
  {
    id: 'inventario',
    title: 'Inventário',
    icon: Boxes,
    items: [
      { to: '/inventario', label: 'Itens', icon: Package, roles: INVENTARIO_CONSULTA, end: true },
      {
        to: '/inventario/responsaveis',
        label: 'Minha equipe',
        icon: UsersRound,
        roles: INVENTARIO_MINHA_EQUIPE,
      },
      { to: '/inventario/categorias', label: 'Categorias', icon: Tags, roles: INVENTARIO_GESTAO },
    ],
  },
  {
    id: 'operacional',
    title: 'Operacional',
    icon: MapPinCheck,
    items: [
      {
        to: '/operacional',
        label: 'Visão geral',
        icon: ChartNoAxesCombined,
        roles: OPERACIONAL_PAINEL,
        end: true,
      },
      {
        to: '/operacional/calendario',
        label: 'Calendário',
        icon: CalendarDays,
        roles: OPERACIONAL_CALENDARIO,
      },
      {
        to: '/operacional/revisao',
        label: 'Revisão',
        icon: ClipboardCheck,
        roles: OPERACIONAL_REVISAO,
      },
      {
        to: '/operacional/relatorios',
        label: 'Relatórios',
        icon: FileCheck2,
        roles: OPERACIONAL_RELATORIOS,
      },
      {
        to: '/operacional/roteiros',
        label: 'Roteiros',
        icon: ListChecks,
        roles: OPERACIONAL_PLANEJAMENTO,
      },
      {
        to: '/operacional/unidades',
        label: 'Unidades',
        icon: Building,
        roles: OPERACIONAL_PLANEJAMENTO,
      },
      {
        to: '/operacional/equipes',
        label: 'Equipes',
        icon: UsersRound,
        roles: OPERACIONAL_PLANEJAMENTO,
      },
    ],
  },
  {
    id: 'financeiro',
    title: 'Financeiro',
    icon: Wallet,
    items: [
      {
        to: '/financeiro',
        label: 'Visão geral',
        icon: ChartNoAxesCombined,
        roles: FINANCEIRO_CONSULTA,
        end: true,
      },
      {
        to: '/financeiro/contas-a-pagar',
        label: 'Contas a pagar',
        icon: Receipt,
        roles: FINANCEIRO_CONSULTA,
      },
      {
        to: '/financeiro/contas-a-receber',
        label: 'Contas a receber',
        icon: HandCoins,
        roles: FINANCEIRO_CONSULTA,
      },
      {
        to: '/financeiro/transferencias',
        label: 'Transferências',
        icon: ArrowLeftRight,
        roles: FINANCEIRO_CONSULTA,
      },
      {
        to: '/financeiro/reembolsos',
        label: 'Reembolsos',
        icon: ReceiptText,
        roles: FINANCEIRO_CONSULTA,
      },
      {
        to: '/financeiro/orcamentos',
        label: 'Orçamentos',
        icon: ClipboardList,
        roles: FINANCEIRO_CONSULTA,
      },
      {
        to: '/financeiro/contratos',
        label: 'Contratos',
        icon: FileSignature,
        roles: FINANCEIRO_CONSULTA,
      },
      {
        to: '/financeiro/clientes',
        label: 'Clientes',
        icon: Building2,
        roles: FINANCEIRO_CONSULTA,
      },
      {
        to: '/financeiro/fornecedores',
        label: 'Fornecedores',
        icon: Truck,
        roles: FINANCEIRO_CONSULTA,
      },
      {
        to: '/financeiro/configuracoes',
        label: 'Configurações',
        icon: Settings,
        roles: FINANCEIRO_CONSULTA,
      },
    ],
  },
]
